import React from "react";

import styled from "styled-components";
import { THEME_MAP } from "../theme";

const Container = styled.div`
	height: 100%;
	width: 100%;

	padding: 24px;
	overflow: auto;
	position: relative;
`;

export const LocalAds = () => {
	return (
		<Container style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
			<h2 style={{ color: THEME_MAP["color-basic-600"] }}>Under Construction</h2>
		</Container>
	);
};